import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ShieldAlert } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [denied, setDenied] = useState(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data);
        window.history.replaceState({}, document.title, "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: data } });
      } catch (e) {
        if (e?.response?.status === 403) {
          window.history.replaceState({}, document.title, "/");
          setDenied(true);
        } else {
          navigate("/", { replace: true });
        }
      }
    })();
  }, [navigate, setUser]);

  if (denied) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6" data-testid="auth-denied">
        <div className="brut-card p-10 max-w-md text-center">
          <ShieldAlert className="mx-auto mb-4 text-[#E63946]" size={48} strokeWidth={2.5} />
          <div className="text-xs uppercase tracking-[0.2em] text-[#E63946] font-bold mb-2">── 403 / ACCESS DENIED</div>
          <h1 className="font-heading font-black text-3xl tracking-tighter mb-3">YOU'RE NOT ON THE LIST.</h1>
          <p className="text-sm text-[#666] mb-6">
            This Gmail account isn't authorized. Ask your admin to invite you in the <b>Users</b> page.
          </p>
          <a href="/" className="brut-btn brut-btn-primary inline-flex" data-testid="back-to-login-btn">
            BACK TO LOGIN
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <div className="brut-card px-10 py-8 font-heading text-2xl">SIGNING YOU IN…</div>
    </div>
  );
}
